import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Admin from "./Admin";
import GuildLibrarian from "./GuildLibrarian";
import Mrt from "./Mrt";
import Mis from "./Mis";
import Typist from "./Typist";
import GroupAdmin from "./GroupAdmin";
import ErrorPage from "../components/ErrorPages/ErrorPage";

import { history } from "../appRedux/store";

const App = React.memo(({ match, grantedRoute }) => {
  return (
    <div className="gx-main-content-wrapper">
      {
        grantedRoute === "admin" ?
          <Switch>
            <Route path={`${match.url}admin`} component={Admin} />
            <Route
              path={`${match.url}unauthorized`}
              component={() => <ErrorPage errorCode={403} errorAction="goHome" handleAction={() => history.push('/admin/dashboard')} />}
            />
            <Redirect to="/unauthorized" />
          </Switch> :
          grantedRoute === "guildlibrarian" ?
            <Switch>
              <Route path={`${match.url}guildlibrarian`} component={GuildLibrarian} />
              <Route
                path={`${match.url}unauthorized`}
                component={() => <ErrorPage errorCode={403} errorAction="goHome" handleAction={() => history.push('/guildlibrarian/public-macros')} />}
              />
              <Redirect to="/unauthorized" />
            </Switch> :
            grantedRoute === "groupadmin" ?
              <Switch>
                <Route path={`${match.url}groupadmin`} component={GroupAdmin} />
                <Route
                  path={`${match.url}unauthorized`}
                  component={() => <ErrorPage errorCode={403} errorAction="goHome" handleAction={() => history.push('/guildlibrarian/public-macros')} />}
                />
                <Redirect to="/unauthorized" />
              </Switch> :
              grantedRoute === "mrt" ?
                <Switch>
                  <Route path={`${match.url}mrt`} component={Mrt} />
                  <Route
                    path={`${match.url}unauthorized`}
                    component={() => <ErrorPage errorCode={403} errorAction="goHome" handleAction={() => history.push('/mrt/dashboard')} />}
                  />
                  <Redirect to="/unauthorized" />
                </Switch> :
                grantedRoute === "mis" ?
                  <Switch>
                    <Route path={`${match.url}mis`} component={Mis} />
                    <Route
                      path={`${match.url}unauthorized`}
                      component={() => <ErrorPage errorCode={403} errorAction="goHome" handleAction={() => history.push('/mis/dashboard')} />}
                    />
                    <Redirect to="/unauthorized" />
                  </Switch> :
                  grantedRoute === "typ" ?
                    <Switch>
                      <Route path={`${match.url}typ`} component={Typist} />
                      <Route
                        path={`${match.url}unauthorized`}
                        component={() => <ErrorPage errorCode={403} errorAction="goHome" handleAction={() => history.push('/typ/dashboard')} />}
                      />
                      <Redirect to="/unauthorized" />
                    </Switch>
                    : <Redirect to="/unauthorized" />
      }
    </div>
  )
});

export default App;
